import { Customer } from "../types/customer";
import { CustomerType } from "../enums/customerType";

export const SampleCustomers: Customer[] = [
  {
    id: "CUST-001",
    companyId: "COMP-001",
    name: "John Doe",
    phone: "+1-555-0101",
    email: "john.doe@example.com",
    type: CustomerType.INDIVIDUAL,
    address: {
      country: "Rwanda",
      province: "Kigali",
      district: "Nyarugenge",
      sector: "Nyamirambo",
      cell: "Nyamirambo",
      village: "Nyamirambo",
      streetAddress: "101 Main St"
    }
  },
  {
    id: "CUST-002",
    companyId: "COMP-001",
    name: "Jane Smith",
    phone: "+1-555-0102",
    email: "jane.smith@example.com",
    type: CustomerType.INDIVIDUAL,
    address: {
      country: "Rwanda",
      province: "Kigali",
      district: "Gasabo",
      sector: "Kimisagara",
      cell: "Kimisagara",
      village: "Kimisagara",
      streetAddress: "202 Oak Ave"
    }
  },
  {
    id: "CUST-003",
    companyId: "COMP-001",
    name: "Tech Solutions Inc.",
    tin: "12-3456789",
    phone: "+1-555-0103",
    email: "contact@techsolutions.com",
    type: CustomerType.COMPANY,
    address: {
      country: "Rwanda",
      province: "Kigali",
      district: "Kicukiro",
      sector: "Gikondo",
      cell: "Gikondo",
      village: "Gikondo",
      streetAddress: "303 Pine Rd"
    }
  },
  {
    id: "CUST-004",
    companyId: "COMP-001",
    name: "Emily Davis",
    phone: "+1-555-0104",
    type: CustomerType.INDIVIDUAL
  },
  {
    id: "CUST-005",
    companyId: "COMP-001",
    name: "Global Trading Ltd.",
    tin: "98-7654321",
    phone: "+1-555-0105",
    email: "info@globaltrading.com",
    type: CustomerType.COMPANY
  }
];
